<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" [modalHelpIndex]="modalHelpIndex"
    [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()"
    [modalClass]="modalClass" [isPrimaryBtnEnabled]="okEnabled()" [secondaryButtonLabel]="secondaryButtonLabel"
    [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage" [buttonTemplate]="validateButtonTemplate">
    <div class="content">
        <res-name-description [name]="nameDescriptionComponent.name" [nameLabel]="'Name:'" [isDescriptionHidden]="true"
            [validateNameRequest]="validateNameRequest" [attr.maxlength]="nameDescriptionComponent.maxNameLength"
            [changeInputStyleWhenNotValid]="true" [validateName]="true" [automationId]="modalAutomationId"
            [isNameDisabled]="isEditStorage">
        </res-name-description>
        <div class="modal-row">
            <div class="modal-row-column-auto">
                <label for="role">Storage Type:</label>
            </div>
            <div class="modal-row-column-max">
                <div class="button-group">
                    <button [attr.data-automation-id]="modalAutomationId + '-document-button'" type="button"
                        [ngClass]="storageType === StorageType.Document ? 'btn-group-active' : 'btn-group-default'"
                        (click)="setType(StorageType.Document)" [disabled]="isEditStorage">
                        <div>Document</div>
                        <i class="fa fa-caret-up up-caret-active" [hidden]="storageType !== StorageType.Document"></i>
                    </button>
                    <button [attr.data-automation-id]="modalAutomationId + '-index-button'" type="button"
                        title="{{disableIndexTab ? 'Index Storage already exists.' : ''}}"
                        [ngClass]="storageType === StorageType.Index ? 'btn-group-active' : 'btn-group-default'"
                        (click)="setType(StorageType.Index)" [disabled]="isEditStorage || disableIndexTab">
                        <div>Index</div>
                        <i class="fa fa-caret-up up-caret-active" [hidden]="storageType !== StorageType.Index"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="modal-row">
            <div class="modal-row-column-auto">
                <label requiredAsterisk [isRequired]="!elementsDisabled()">IP Address / Host Name:</label>
            </div>
            <div class="modal-row-column-max node-or-host-name-selection">
                <input type="text" name="ip" id="ipInput" [(ngModel)]="selectedNodeOrHost"
                    (change)="onNodeOrHostChanged($event)"
                    [attr.data-automation-id]="modalAutomationId + '-ip-address-input'"
                    [disabled]="elementsDisabled()" />
            </div>
        </div>
        <div class="modal-row">
            <div class="modal-row-column-auto">
                <label requiredAsterisk [isRequired]="!elementsDisabled()">Storage Path:</label>
            </div>
            <div class="modal-row-column-max storage-paths-selection" [title]="tooltipWhenDisabled">
                <res-custom-combo-box [items]="allStoragePaths" [allItems]="allStoragePaths"
                    [disabled]="dropdownDisabled()" [onSelectionChanged]="onStoragePathChanged"
                    [selectedItem]="selectedStoragePath" [onInputFocusLost]="onFocusChanged" [fillWidth]="true"
                    [automationId]="modalAutomationId + '-storage-path'"></res-custom-combo-box>
            </div>
        </div>
        <div class="modal-row">
            <div class="modal-row-column-auto">
                <label>File System / Protocol:</label>
            </div>
            <div class="modal-row-column-max">
                <res-custom-radio-button [(ngModel)]="fileSystemProtocol" [disabled]="elementsDisabled()" content="NFS"
                    name="fileSystemProtocol" value="NFS" [automationId]="modalAutomationId + '-nfs'"
                    (ngModelChange)="hideValidationPopup()"></res-custom-radio-button>
                <res-custom-radio-button [(ngModel)]="fileSystemProtocol" [disabled]="elementsDisabled()"
                    content="PanFS ®" name="fileSystemProtocol" value="PANFS"
                    [automationId]="modalAutomationId + '-panfs'"
                    (ngModelChange)="hideValidationPopup()"></res-custom-radio-button>
            </div>
        </div>
    </div>
    <ng-template #validateButtonTemplate>
        <button type="button" [attr.data-automation-id]="modalAutomationId + '-validate-button'"
            class="secondary-button validate-button" (click)="validate()" [disabled]="!validateEnabled()">
            <i class="fa fa-check fa-icon sizing-icons"></i>Validate
        </button>
        <div class="validation-error">
            <span class="error-popover" [attr.data-automation-id]="modalAutomationId + '-validation-label'"
                containerClass="success" [container]="'.' + modalClass" [popover]="validationPopTmpl" triggers=""
                #validationPop="bs-popover" placement="left"></span>
            <ng-template #validationPopTmpl>
                <span [attr.data-automation-id]="modalAutomationId +  '-validate-label'">{{isValid ?
                    'Storage is valid.' : 'Storage is invalid.'}}</span>
                <i class="fa fa-close" (click)="validationPop.hide()"
                    [attr.data-automation-id]="modalAutomationId + '-validate-exit-button'"></i>
            </ng-template>
        </div>
    </ng-template>
</res-base-modal>